export default (profileData: string, type: string = "profile"): string => `
Here is context about their ${type}:

${profileData}
`;
